export default __webpack_public_path__ + "static/icoIg-8ff5c59145c9b1cca329b123b518c8b7.svg";